import PropTypes from "prop-types";
import SmallScreenHeader from "../../../../../containers/SmallScreenHeader";

const Facets = () => (
  <>
    <SmallScreenHeader />
  </>
);

Facets.propTypes = {
  viewportCategory: PropTypes.string.isRequired
};

export default Facets;
